import { render, staticRenderFns } from "./BellAlbum.vue?vue&type=template&id=1e3ff9cb&scoped=true&"
import script from "./BellAlbum.vue?vue&type=script&lang=js&"
export * from "./BellAlbum.vue?vue&type=script&lang=js&"
import style0 from "./BellAlbum.vue?vue&type=style&index=0&id=1e3ff9cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3ff9cb",
  null
  
)

export default component.exports